export const handleAssessmentTimer = (startTime) => {
  const requestTime = (new Date().getTime() - startTime) / 1000;
  const secondsLeft = localStorage.getItem("secondsLeft");

  if (secondsLeft) {
    const newTime = parseInt(secondsLeft) + requestTime;
    localStorage.setItem("secondsLeft", `${newTime}`);
  }
};
